/* eslint-disable */

import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

const breakpoint = window.matchMedia('(min-width: 992px)');

let mySliders = [];

function enableSwiper() {
  const sliderElements = document.querySelectorAll('.swiper-grid .swiper-container');

  if (!sliderElements.length > 0) return;

  sliderElements.forEach((el) => {
    const btnNext = el.querySelector('.btn-next');
    const btnPrev = el.querySelector('.btn-prev');
    const paginationEl = el.querySelector('.swiper-pagination');

    const slider = new Swiper(el, {
      loop: false,
      spaceBetween: 8,
      centeredSlidesBounds: true,
      centeredSlides: true,
      slidesPerView: 1.2,
      observeParents: true,
      watchSlidesProgress: true,
      a11y: true,
      keyboardControl: true,
      autoHeight: false,
      modules: [Navigation, Pagination],
      navigation: {
        nextEl: btnNext,
        prevEl: btnPrev,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        350: {
          slidesPerView: 2.1,
          spaceBetween: 8,
          centeredSlides: false,
          centeredSlidesBounds: false,
        },
        650: {
          slidesPerView: 3.2,
          spaceBetween: 8,
          centeredSlides: false,
          centeredSlidesBounds: false,
        },
      },
    });

    mySliders.push(slider);
  });
}

function swiperBreakpointChecker() {
  // if larger viewport and multi-row layout needed

  if (breakpoint.matches === true) {
    if (mySliders.length > 0) {
      for (let index = 0; index < mySliders.length; index += 1) {
        const mySwiper = mySliders[Number(index)];

        if (mySwiper !== undefined) mySwiper.destroy(true, true);
      }
      mySliders = [];
    }
  } else {
    enableSwiper();
  }
}

if (breakpoint.addEventListener) {
  breakpoint.addEventListener('change', swiperBreakpointChecker);
} else {
  breakpoint.addListener(swiperBreakpointChecker);
}

window.addEventListener('load', () => {
  swiperBreakpointChecker();
});
